import { Roles, Tenants } from "config";
import { Optional } from "infrastructure";
import { stringHelpers } from "infrastructure/helpers";
import { IUserRoleAccess } from "ui/shared/models/common";

import { IAuthorizationData, IRole } from "./UserProvider.state";

export const convertToRoles = (authorizationData: IAuthorizationData[] = []): Array<Optional<IRole, "enterprise" | "tenant">> => {
  const result: Array<Optional<IRole, "enterprise" | "tenant">> = [];

  authorizationData.forEach(authData => {
    if (authData.enterprises?.length) {
      authData.enterprises.forEach(enterprise => {
        enterprise &&
          authData.roles.forEach(role => {
            result.push({
              enterprise: enterprise,
              role: role
            });
          });
      });
    } else if (authData.tenants?.length) {
      authData.tenants.forEach(tenant => {
        tenant &&
          authData.roles.forEach(role => {
            result.push({
              tenant: tenant,
              role: role
            });
          });
      });
    } else {
      authData.roles.forEach(role => {
        role &&
          result.push({
            role: role
          });
      });
    }
  });

  return result;
};

export const checkAuthorization = (roles: IRole[], authorizationData: IAuthorizationData[], tenantId?: string) => {
  let result = false;

  const checkingRoles = convertToRoles(authorizationData);

  if (checkingRoles.length) {
    if (tenantId) {
      checkingRoles.forEach(checking => {
        if (!result) {
          result = roles.some(e => {
            let authorized = false;
            if (stringHelpers.equal(e.tenant, tenantId)) {
              if (checking.enterprise) {
                authorized = stringHelpers.equal(checking.enterprise, e.enterprise) && stringHelpers.equal(checking.role, e.role);
              } else if (checking.tenant) {
                authorized = stringHelpers.equal(checking.tenant, e.tenant) && stringHelpers.equal(checking.role, e.role);
              } else {
                authorized = stringHelpers.equal(checking.role, e.role);
              }
            }

            return authorized;
          });
        }
      });
    }
  } else {
    result = true;
  }

  return result;
};

export const createUserRoleAccessData = (roles: IRole[], tenantId?: string) => {
  const userRoleAccess: IUserRoleAccess = {
    PlexLocalizationManager: checkAuthorization(roles, [{ roles: [Roles.PlexLocalizationManager], tenants: [Tenants.Plex] }], tenantId),
    PlexReleaseManager: checkAuthorization(roles, [{ roles: [Roles.PlexReleaseManager], tenants: [Tenants.Plex] }], tenantId),
    PlexSecurityAdmin: checkAuthorization(roles, [{ roles: [Roles.PlexSecurityAdmin], tenants: [Tenants.Plex] }], tenantId),
    PlexTechnicalWriter: checkAuthorization(roles, [{ roles: [Roles.PlexTechnicalWriter], tenants: [Tenants.Plex] }], tenantId),
    // Translator can be only in Plex tenant
    Translator: checkAuthorization(roles, [{ roles: [Roles.Translator], tenants: [Tenants.Plex] }], tenantId),
    LocalizationManager: checkAuthorization(roles, [{ roles: [Roles.LocalizationManager] }], tenantId),
    SecurityAdmin: checkAuthorization(roles, [{ roles: [Roles.SecurityAdmin] }], tenantId)
  };

  return userRoleAccess;
};
